import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">吃瓜热度榜</h2>
          <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full">TOP 6</span>
        </div>

        <div className="flex flex-col gap-2">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-accent-50/50 transition-colors border border-background-200/70 cursor-pointer"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-black flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-accent-400 text-white' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-bold text-foreground-800 group-hover:text-accent-600 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-secondary-100 text-secondary-600 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                {item.change === 'hot' ? (
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                ) : item.change === 'up' ? (
                  <i className="ri-arrow-up-line text-primary-500 text-sm"></i>
                ) : (
                  <i className="ri-arrow-down-line text-secondary-400 text-sm"></i>
                )}
                <span className="text-sm font-bold text-foreground-600 whitespace-nowrap">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}